import Snackbar from '../Snackbar';

export default class ImageWithButton extends Snackbar {
  static templateId = 'image-with-button';

  static elements = [
    'imageContainer',
    'image',
    'detailsContainer',
    'textContainer',
    'buttonContainer',
  ];

  constructor(...args) {
    super(...args);
    this.prepare();
  }

  prepare() {
    const { text, buttonText, image } = this.options;
    const buttonTextEl = this.buttonContainer.querySelector('.btn__text');

    this.textContainer.textContent = text;
    buttonTextEl.textContent = buttonText;
    this.image.src = image;

    return this;
  }
}
